import { render, staticRenderFns } from "./ProjectStatsDashboard.vue?vue&type=template&id=9b4cb5e2&"
import script from "./ProjectStatsDashboard.vue?vue&type=script&lang=js&"
export * from "./ProjectStatsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStatsDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports